<template>
  <div class="page_container">
    <div v-if="isShowModal" class="use_pop_container">
      <div class="use_pop_box">
        <img @click="handleOnOffModal" src="../assets/img/relocation/icon_close.png" alt="닫기" />
        <div class="use_pop">
          <h2>개인정보 수집 및 이용</h2>
          <p>
            개인정보 처리방침 ㈜캐럿글로벌(이하 “회사”라고 함)은 개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 지켜야할 관련
            법령상의 개인정보보호 규정을 준수하고 있습니다. 당사의 개인정보처리방침은 정부의 법률/지침 변경 혹은 ㈜캐럿글로벌의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를 개정/변경하는 경우
            당사의 홈페이지에 변경사항을 즉시 게시하고 있습니다. 본 개인정보처리방침의 목차는 아래와 같습니다. <br /><br />1. 수집하는 개인정보의 항목 및 수집방법 <br />2. 개인정보의 수집 및 이용목적
            <br />3. 개인정보의 보유 및 이용기간 <br />4. 개인정보의 파기절차 및 방법 <br />5. 개인정보 <br />6. 수집한 개인정보의 위탁 <br />7. 이용자 및 법정대리인의 권리와 그 행사방법 <br />8.
            개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항 <br />9. 개인정보 위탁 현황 <br />10. 개인정보 관리 책임자 <br />11. 고지의 의무 <br /><br />1. 수집하는 개인정보의 항목 및
            수집방법 ㈜캐럿글로벌은 서비스 문의 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. <br />가. 수집하는 개인정보 항목 1) 서비스 문의 시 아래 항목을 수집합니다. - 필수항목: 회사명,
            담당자명, 연락처, 이메일, 문의사항 2) 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다. - 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키,
            접속IP정보, 결제기록 - 모바일 이용 시: 서비스 이용 기록, 접속 로그, 기기고유번호(디바이스 아이디 또는 IMEI) 3) 고객 상담 시 서비스 품질 향상을 위해 담당자 연결 후 통화내용이 녹음되어
            아래와 같은 정보들을 수집합니다. - 통화이력 및 녹음 파일 <br />나. 수집방법 1) 홈페이지를 통한 이벤트 응모, 전화, 팩스, 고객센터 문의 및 상담 2) 생성정보 수집 툴을 통한 수집 <br /><br />2.
            개인정보의 수집 및 이용목적 ㈜캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다. ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 콘텐츠 제공, 구매 및 요금 결제,
            본인인증, 물품배송 또는 청구지 등 발송 ο 회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등
            민원처리, 고지사항 전달 ο 마케팅 및 광고에 활용 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의
            서비스 이용에 대한 통계 ο 기타 가입횟수 제한, 분쟁조정을 위한 기록보존, 회원의 각종 합격유무 확인 및 기타 통계자료 산출 <br /><br />3. 개인정보의 보유 및 이용기간 회사는 원칙적으로
            개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다. ο 파기절차:회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후
            별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는
            법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다. ο 파기방법:전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. ο
            보유기간:이용계약에 따른 회원자격이 유지되는 기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가 있는 경우 ㈜캐럿글로벌은 아래와 같이 일정 기간동안 회원정보를
            보관합니다. 회원 및 비회원 통화 이력은 상담 종료 후 30일동안 보관된 후 파기됩니다. <br /><br />4. 개인정보의 파기절차 및 방법 개인정보의 보유 및 이용기간은 다음과 같습니다. ο
            보유항목:수집항목과 같습니다. ο 보유근거:이용약관 및 개인정보취급방침 ο 보유기간:이용계약에 따른 회원자격이 유지되는 기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가
            있는 경우 ㈜캐럿글로벌은 아래와 같이 일정 기간동안 회원정보를 보관합니다. 표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률) 계약 또는 청약철회 등에 관한 기록 : 5년
            (전자상거래등에서의 소비자보호에 관한 법률) 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률) 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
            (전자상거래등에서의 소비자보호에 관한 법률) 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률) 통신비밀보호법에 따른 통신사실확인자료 3개월
            <br /><br />5. 개인정보 ㈜캐럿글로벌은 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다. 이용자들이 사전에 동의한 경우 - 법령의 규정에
            의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 <br /><br />6. 수집한 개인정보의 위탁 ㈜캐럿글로벌은 고객님의 동의없이 고객님의 정보를 외부 업체에
            위탁하지 않습니다. 향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다. <br /><br />7. 이용자 및 법정대리인의
            권리와 그 행사방법 이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. 이용자 혹은 만
            14세 미만 아동의 개인정보 조회를 위해서는 ‘정보수정’ 을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭 하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은
            개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다. 귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전 까지 개인정보를 이용 또는
            제공하지 않습니다. 또한 잘못된 개인정보를 제3자 에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다. ㈜캐럿글로벌은 이용자 혹은 법정
            대리인의 요청에 의해 해지 또는 삭제된 개인정보는 ㈜캐럿글로벌이 수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
            있습니다. <br /><br />8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항 ㈜캐럿글로벌은 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다. 쿠키란
            ㈜캐럿글로벌의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. ㈜캐럿글로벌은 다음과 같은 목적을 위해 쿠키를
            사용합니다. 쿠키 등 사용 목적 - 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅
            및 개인 맞춤 서비스 제공 쿠키 설정 거부 방법 - 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을
            거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. - 설정방법 예(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 (단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스
            제공에 어려움이 있을 수 있습니다.) <br /><br />9. 개인정보 위탁 현황 고객지원 및 서비스 제공을 위해 아래와 같이 개인정보 취급 업무를 외부 업체에 위탁하여 운영하고 있습니다. 위탁계약시
            개인정보보호의 안전을 기하기 위하여 개인정보보호 관련 지시 엄수, 개인정보에 관한 유출금지 및 사고시의 책임부담 등을 명확히 규정하고 위탁계약 내용에 포함하고 있습니다. 수탁업체 위탁목적
            ㈜다우기술 SMS 발송대행 <br /><br />10. 개인정보 관리 책임자 ㈜캐럿글로벌은 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및
            개인정보관리책임자를 지정하고 있습니다. <br /><br />개인정보관리책임자 성명 : 이은경 본부장 <br />전화번호 : 02-518-5467 (평일 : 9시 ~ 6시까지) <br />이메일 : ashleylee@carrotglobal.com
            <br /><br />기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다. <br />• 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118) • 대검찰청 사이버수사과
            (www.spo.go.kr / 국번없이 1301) • 경찰청 사이버수사국 (police.go.kr / 국번없이 182) <br /><br />11. 고지의 의무 현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 변경사항 시행일의
            7일전부터 홈페이지를 통해 고지할 것입니다. - 공고일자: 2021년 5월 26일 - 시행일자: 2021년 6월 2일
          </p>
        </div>
      </div>
    </div>
    <!-- 둥둥이 -->
    <div class="side_btn">
      <div class="estimate">
        <a href="/re-location-contact" target="_blank">
          <img src="../assets/img/relocation/icon_estimate.png" alt="견적내기" />
          <h4>견적 내기</h4>
        </a>
      </div>
      <div class="question">
        <a href="#question">
          <img src="../assets/img/relocation/icon_question.png" alt="문의하기" />
          <h4>문의 하기</h4>
        </a>
      </div>
    </div>
    <!-- 메인 상단 -->
    <main>
      <header>
        <img src="../assets/img/relocation/logo.png" alt="로고" />
      </header>
      <h1>
        <span>두려움을 설렘으로<br />주재원의 안정적인 정착을 돕는</span>
        리:로케이션 서비스
      </h1>
      <div class="btn">
        <a
          href="https://kr.object.ncloudstorage.com/mailpad/carrot/%28%EC%BA%90%EB%9F%BF%EA%B8%80%EB%A1%9C%EB%B2%8C%29%20%EB%A6%AC%EB%A1%9C%EC%BC%80%EC%9D%B4%EC%85%98%20%EC%84%9C%EB%B9%84%EC%8A%A4%20%EC%86%8C%EA%B0%9C%EC%84%9C.pdf"
          target="_blank"
          >서비스 소개서 다운로드
          <img src="../assets/img/relocation/icon_arrow_01.png" alt="화살표" />
        </a>
      </div>
      <div class="btn_estimate">
        <a href="https://moaform.com/q/PinxqS" target="_blank"
          >견적 내기
          <img src="../assets/img/relocation/icon_arrow_01.png" alt="화살표" />
        </a>
      </div>
      <div class="btn_question">
        <a href="#question"
          >문의 하기
          <img src="../assets/img/relocation/icon_arrow_01.png" alt="화살표" />
        </a>
      </div>
    </main>

    <!-- 섹션01 -->
    <section class="section_01">
      <h2><span>리:로케이션</span> 서비스란?</h2>
      <p>
        <span>해외 파견시 필요한 서비스</span><br />
        (교육, 비자, 이사, 자녀 교육, 주거 및 안정 등)를<br />
        One-Stop 으로 제공하여, 성공적인 해외파견을 돕습니다.
      </p>
    </section>

    <!-- 네비게이션 -->
    <nav>
      <ul>
        <li class="li_01">
          <a class="pointer" @click="handleIsDispatch"><span>점</span> 파견 확정 및 교육</a>
        </li>
        <li class="li_02">
          <a class="pointer" @click="handleIsDispatchBefore"><span>점</span> 파견 전</a>
        </li>
        <li class="li_03">
          <a class="pointer" @click="handleIsDeparture"><span>점</span> 출국 및 초기정착</a>
        </li>
        <li class="li_04">
          <a class="pointer" @click="handleIsDispatchIng"><span>점</span> 파견 중</a>
        </li>
        <li class="li_05">
          <a class="pointer" @click="handleIsReturn"><span>점</span> 귀임</a>
        </li>
      </ul>
    </nav>

    <!-- 섹션02 -->
    <section class="section_02">
      <!-- 파견 확정 및 교육 (01) -->
      <div class="box_01" id="box_01">
        <img class="dot" src="../assets/img/relocation/icon_road_01.png" alt="파란색점" />
        <h2>파견 확정 및 교육</h2>
        <ul class="step_box_01">
          <li class="gray_box">
            <img src="../assets/img/relocation/icon_pin.png" alt="파견 확정" />
            <h4>STEP. 01</h4>
            <h3><span>파견</span> 확정</h3>
          </li>
          <li>
            <img src="../assets/img/relocation/icon_arrow_02.png" alt="화살표" />
          </li>
          <li class="gray_box">
            <img src="../assets/img/relocation/icon_consult.png" alt="교육 컨설팅" />
            <h4>STEP. 02</h4>
            <h3><span class="w_blue">국가 및 상황</span>에 맞는<br class="br_3" />교육 컨설팅</h3>
          </li>
          <li>
            <img src="../assets/img/relocation/icon_arrow_02.png" alt="화살표" />
          </li>
          <li class="gray_box">
            <img src="../assets/img/relocation/icon_book.png" alt="전문 교육 제공" />
            <h4>STEP. 03</h4>
            <h3>컨설팅에 따른<br class="br_3" /><span> 전문 교육</span> 제공</h3>
          </li>
        </ul>
        <div class="img_box">
          <img src="../assets/img/relocation/img_01.png" alt="주재원 파견 교육" />
          <div class="txt_box">
            <h3>주재원 파견 교육</h3>
            <p>
              체계화 된 주재원 교육 로드맵을 통해 파견이<br class="br" />
              확정된 시점부터 귀임까지 전문적인 주재원 파견<br class="br" />
              교육을 제공합니다. (대면/비대면 교육 제공 가능)
            </p>
          </div>
        </div>
      </div>
      <!-- 파견 전 (02) -->
      <div class="box_defalt box_02" id="box_02">
        <img class="dot" src="../assets/img/relocation/icon_road_02.png" alt="보라색점" />
        <h2>파견 전</h2>
        <ul class="img_container">
          <li class="img_box">
            <img src="../assets/img/relocation/img_02.png" alt="비자 서비스" />
            <div class="txt_box">
              <h3>비자 서비스</h3>
              <p>
                비자신청 컨설팅 및 서류, 인터뷰 준비 등의 서비스를 제공하여,<br class="br" />
                비자에 대한 고민을 해결해드립니다.
              </p>
            </div>
          </li>
          <li class="img_box">
            <img src="../assets/img/relocation/img_03.png" alt="주택 & 이사 서비스" />
            <div class="txt_box">
              <h3>주택 & 이사 서비스</h3>
              <p>
                주택의 구매 및 렌트에 대한 서비스를 일체 제공하고, 국내외<br class="br" />
                이사 서비스를 함께 제공하여 안정적인 거주환경을 유지할 수<br class="br" />
                있도록 돕습니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 출국 및 초기 정착 (03) -->
      <div class="box_defalt box_03" id="box_03">
        <img class="dot" src="../assets/img/relocation/icon_road_03.png" alt="주황색점" />
        <h2>출국 및 초기 정착</h2>
        <ul class="img_container">
          <li class="img_box">
            <img src="../assets/img/relocation/img_04.png" alt="초기 정착 솔루션" />
            <div class="txt_box">
              <h3>초기 정착 솔루션</h3>
              <p>
                파견 후 4주간 정착에 필요한 서비스들 (은행, 휴대폰, 보험,<br class="br" />
                유틸리티 등)에 대한 가이드 및 도움을 제공합니다.
              </p>
            </div>
          </li>
          <li class="img_box">
            <img src="../assets/img/relocation/img_05.png" alt="자녀 유학 서비스" />
            <div class="txt_box">
              <h3>자녀 유학 서비스</h3>
              <p>
                자녀 및 파견국의 상황과 시기에 맞는 학교 검색 및 입학 서비스,<br class="br" />
                교육 커리큘럼을 제공합니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 파견 중 (04) -->
      <div class="box_defalt box_04" id="box_04">
        <img class="dot" src="../assets/img/relocation/icon_road_04.png" alt="녹색점" />
        <h2>파견 중</h2>
        <ul class="img_container">
          <li class="img_box">
            <img src="../assets/img/relocation/img_06.png" alt="마인드 케어 서비스 (심리 상담)" />
            <div class="txt_box">
              <h3>마인드 케어 서비스 (심리 상담)</h3>
              <p>
                파견자 포함 가족들을 대상으로 주기적인 심리 상담 및 코칭을<br class="br" />
                진행하여 정서적인 안정감을 제공합니다.
              </p>
            </div>
          </li>
          <li class="img_box">
            <img src="../assets/img/relocation/img_07.png" alt="자녀 교육 서비스" />
            <div class="txt_box">
              <h3>자녀 교육 서비스</h3>
              <p>
                파견 전, 중으로 자녀의 교육을 다방면으로 제공합니다.<br class="br" />
                영어, 현지어, 이문화 교육 / 국내 입시 과목 과외 / 국제학교<br class="br" />
                진학 특강 등
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 귀임 (05) -->
      <div class="box_defalt box_05" id="box_05">
        <img class="dot" src="../assets/img/relocation/icon_road_05.png" alt="분홍색점" />
        <h2>귀임</h2>
        <ul class="img_container">
          <li class="img_box">
            <img src="../assets/img/relocation/img_08.png" alt="가족 재정착 서비스" />
            <div class="txt_box">
              <h3>가족 재정착 서비스</h3>
              <p>
                자녀의 한국 학교 재입학 및 국내 교육 적응을 돕는 서비스와<br class="br" />
                문화 역충격을 대비한 교육 서비스를 제공합니다.
              </p>
            </div>
          </li>
          <li class="img_box">
            <img src="../assets/img/relocation/img_09.png" alt="귀임 후 서비스" />
            <div class="txt_box">
              <h3>귀임 후 서비스</h3>
              <p>
                파견자의 경험을 DB화 할 수 있도록 인터뷰 및 Case 제작 /
                <br class="br" />
                귀임보고서 작성 등을 돕는 서비스를 제공 합니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 섹션03 -->
    <section class="section_03">
      <h2>ONE STOP 해외 파견 서비스</h2>
      <p>
        해외 파견, 주재원, 역주재원의 파견 전, 파견 준비, 파견 중, 귀임까지의 전 과정을 One STOP 서비스를 제공하여,<br class="br" />
        <span>해외 파견의 두려움을 설렘과 자신감으로 전환</span>합니다.
      </p>
      <!-- WODUCATION 박스 -->
      <div class="onestop_box">
        <h3>WODUCATION</h3>
        <p>Work<span>+</span>Edu<span>+</span>Vacation</p>
        <div class="lr_box">
          <div class="l_box">
            <h4>파견 전</h4>
            <div class="diagram_box">
              <div class="circle_01 circle_001">
                파견을 위한<br />
                진단 & 교육 제공
              </div>
              <div class="circle_01">
                파견시 필요한<br />
                필수 분야에 대한<br />
                서비스 제공
              </div>
              <img src="../assets/img/relocation/icon_plus_01.png" alt="+" />
            </div>
            <p>언어, 이문화 교육 및 비자, 이사, 현지 적응 등</p>
          </div>
          <div class="r_box">
            <h4>파견 중/후</h4>
            <div class="diagram_box">
              <div class="circle_02 circle_002">
                현지 적응을 위한<br />
                업체 연결 및<br />
                가족 적응
              </div>
              <div class="circle_02">
                심리상담 및<br />
                귀임자 솔루션 제공
              </div>
              <img src="../assets/img/relocation/icon_plus_02.png" alt="+" />
            </div>
            <p>현지 업체 연결 제공 및 성공적인 귀임을 위한 프로그램 등</p>
          </div>
        </div>
      </div>
      <!-- 점점점 -->
      <img class="arrow_circle" src="../assets/img/relocation/icon_arrow_03.png" alt="..." />
      <!-- 리로케이션 서비스 4가지 -->
      <h2 class="sub_txt">캐럿글로벌만의 차별화 된<br /><span>리:로케이션 서비스</span>를 제공합니다.</h2>
      <div class="service_img_box">
        <div class="service_img_01">
          <img src="../assets/img/relocation/service_img_01.png" alt="서비스 이미지01" />
          <p>
            A-Z까지 원스톱으로<br class="br_2" />
            서비스 제공
          </p>
        </div>
        <div class="service_img_02">
          <img src="../assets/img/relocation/service_img_02.png" alt="서비스 이미지02" />
          <p>
            주재원 파견 전문교육 제공<br class="br_2" />
            및 레퍼런스 보유
          </p>
        </div>
        <div class="service_img_03">
          <img src="../assets/img/relocation/service_img_03.png" alt="서비스 이미지03" />
          <p>
            주재원의 배우자와 자녀까지<br class="br_2" />
            안정적인 정착 솔루션 제공
          </p>
        </div>
        <div class="service_img_04">
          <img src="../assets/img/relocation/service_img_04.png" alt="서비스 이미지04" />
          <p>
            심리상담 및 코칭을 통한<br class="br_2" />
            마인드케어
          </p>
        </div>
      </div>
    </section>

    <!-- 섹션04 -->
    <section class="section_04">
      <h2>프로세스</h2>
      <ul class="process_container">
        <li class="process_box">
          <img src="../assets/img/relocation/icon_step01.png" alt="서비스 문의" />
          <h4>STEP. 01</h4>
          <h3>서비스 문의</h3>
          <p>리:로케이션 서비스 홈페이지 혹은<br class="br" />캐럿글로벌 인바운드를 통해 서비스 문의</p>
        </li>
        <li class="process_box">
          <img src="../assets/img/relocation/icon_step02.png" alt="서비스 문의" />
          <h4>STEP. 02</h4>
          <h3>의뢰서 작성 및 견적 제공</h3>
          <p>서비스 착수 시작 전<br class="br" />의뢰서 작성 및 견적서 송부</p>
        </li>
        <li class="process_box">
          <img src="../assets/img/relocation/icon_step03.png" alt="서비스 문의" />
          <h4>STEP. 03</h4>
          <h3>컨설팅 및 서비스</h3>
          <p>확정 후 개별 컨설팅 및<br class="br" />리:로케이션 서비스 착수 및 제공</p>
        </li>
      </ul>
      <p>※ 의뢰서 작성 시 <span>희망하시는 서비스</span>를 선택할 수 있습니다.</p>
    </section>

    <!-- 섹션05 -->
    <section class="section_05" id="question">
      <h2>서비스 문의</h2>
      <p>문의를 남겨주시면 담당자가 확인 후 최대한 빠른 시간 내에 연락드리겠습니다.</p>
      <div class="question_container">
        <div class="question_box">
          <div>
            <label for="company">회사명</label>
            <input type="text" name="company" v-model="inquiryData.company" placeholder="회사명을 입력해 주세요." />
          </div>
          <div>
            <label for="name">담당자명</label>
            <input type="text" name="name" v-model="inquiryData.manager" placeholder="담당자명을 입력해 주세요." />
          </div>
          <div>
            <label for="callnumber">연락처</label>
            <input type="text" name="callnumber" v-model="inquiryData.phone" placeholder="연락처를 입력해 주세요." />
          </div>
          <div>
            <label for="email">이메일</label>
            <input type="email" name="email" v-model="inquiryData.email" placeholder="이메일을 입력해 주세요." />
          </div>
          <div>
            <label for="">유입경로</label>
            <ul class="funnel-list">
              <li>
                <input type="radio" name="path" id="path1" value="path1" v-model="selectEnterPath" />
                <label for="path1" class="pointer">캐럿 담당자 미팅</label>
              </li>
              <li>
                <input type="radio" name="path" id="path2" value="path2" v-model="selectEnterPath" />
                <label for="path2" class="pointer">캐럿 컨퍼런스 및 설명회 등 모임</label>
              </li>
              <li>
                <input type="radio" name="path" id="path3" value="path3" v-model="selectEnterPath" />
                <label for="path3" class="pointer">온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)</label>
              </li>
              <li>
                <input type="radio" name="path" id="path4" value="path4" v-model="selectEnterPath" />
                <label for="path4" class="pointer">인터넷 검색</label>
              </li>
              <li>
                <input type="radio" name="path" id="path5" value="path5" v-model="selectEnterPath" />
                <label for="path5" class="pointer">캐럿글로벌 종합안내서 책자 및 사보 등 자료</label>
              </li>
              <li>
                <input type="radio" name="path" id="path6" value="path6" v-model="selectEnterPath" />
                <label for="path6" class="pointer">타사 담당자 및 전임자 등 지인 소개</label>
              </li>
              <li class="etc">
                <input type="radio" name="path" id="path7" value="path7" v-model="selectEnterPath" />
                <label for="path7" class="pointer">기타</label>
                <input v-show="selectEnterPath === 'path7'" type="text" name="enterPathText" id="enterPathText" class="etc-input" placeholder="직접 입력" v-model="selectEnterPathText" />
              </li>
            </ul>
          </div>
          <div>
            <label for="txtbox">문의사항</label>
            <textarea name="txt_box" v-model="inquiryData.contents" id="txtbox" cols="30" rows="6"></textarea>
          </div>
          <label class="check_label" for="decide"
            ><input type="checkbox" id="decide" v-model="inquiryData.agree" name="decide" /><span @click="handleOnOffModal" class="pop_up">개인정보 수집 및 이용</span>에 동의합니다.
          </label>
          <div @click="handleInquire" class="btn pointer">문의하기</div>
        </div>
        <div class="map_box">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1581.8612553110818!2d127.00223900000002!3d37.538038!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3b21ed0cd5d%3A0x654d19be7077c57!2z7ISc7Jq47Yq567OE7IucIOyaqeyCsOq1rCDsnbTtg5zsm5DroZwgMjY4LTIw!5e0!3m2!1sko!2skr!4v1664963844201!5m2!1sko!2skr"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d790.9289602435177!2d127.0016033881757!3d37.53819519873153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3b21ed0cd5d%3A0x654d19be7077c57!2z7ISc7Jq47Yq567OE7IucIOyaqeyCsOq1rCDsnbTtg5zsm5DroZwgMjY4LTIw!5e0!3m2!1sko!2skr!4v1650866796319!5m2!1sko!2skr" width="499" height="338" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" style="border: 0px;"></iframe> -->
        </div>
      </div>
    </section>

    <!-- 푸터 -->
    <footer>
      <div class="footer_container">
        <div class="left">
          <div class="contact_box">
            <h4>CONTACT</h4>
            <p>02 - 518 - 0036<br />edu@carrotglobal.com</p>
          </div>
          <div class="adress_box">
            <h4>ADRESS</h4>
            <p>서울특별시 용산구 한남동 이태원로 268-20 캐럿글로벌</p>
          </div>
        </div>
        <div class="right">
          <div class="btn">
            <a href="https://www.carrotglobal.com/global/index.html" target="_blank">캐럿글로벌 바로가기</a>
          </div>
          <p>㈜캐럿글로벌 대표 : 노상충<br />Copyright ©CARROT Global Inc. All Rights reserved.</p>
        </div>
      </div>
      <div>
        <div class="sns-family-wrapper">
          <div class="sns-wrapper">
            <p>FOLLOW US :</p>
            <ul>
              <li>
                <img @click="openPage('https://www.instagram.com/carrotglobal')" src="@/assets/img/newGlobal/main/footer/sns1.png" alt="instagram" />
              </li>
              <li>
                <img @click="openPage('https://www.facebook.com/thecarrotglobal/')" src="@/assets/img/newGlobal/main/footer/sns2.png" alt="facebook" />
              </li>
              <li>
                <img @click="openPage('https://blog.naver.com/carrot_global')" src="@/assets/img/newGlobal/main/footer/sns3.png" alt="blog" />
              </li>
              <li>
                <img @click="openPage('https://www.youtube.com/channel/UCm_Fas_UHeXdiJvF4lADHjA')" src="@/assets/img/newGlobal/main/footer/sns4.png" alt="youtube" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    if (window.location.href.indexOf("#question") > -1) {
      setTimeout(function () {
        window.scrollTo({
          top: document.querySelector("#question").offsetTop + 100,
          behavior: "smooth",
        });
      }, 500);
    }
  },
  components: {},
  data() {
    return {
      isShowModal: false,
      inquiryData: {
        category: "INBOUND",
        company: "", //고객사명
        manager: "", //담당자
        phone: "", //연락처
        email: "", //이메일
        contents: "", //내용
        agree: false,
        enterPath: "", //유입경로
        enterPathText: "",
        enterUrl: window.location.href, //사이트주소
      },
      selectEnterPath: "",
      selectEnterPathText: "",
      pathValue: [
        { key: "path1", value: "캐럿 담당자 미팅" },
        { key: "path2", value: "캐럿 컨퍼런스 및 설명회 등 모임" },
        {
          key: "path3",
          value: "온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)",
        },
        { key: "path4", value: "인터넷 검색" },
        { key: "path5", value: "캐럿글로벌 종합안내서 책자 및 사보 등 자료" },
        { key: "path6", value: "타사 담당자 및 전임자 등 지인 소개" },
        { key: "path7", value: "기타" },
      ],
    };
  },

  methods: {
    gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      this.$gtag('event', 'conversion', {
        'send_to': 'AW-11452452150/CYnaCJ7T0YcZELaa-tQq',
        'event_callback': callback
      });
    },
    handleOnOffModal() {
      this.isShowModal = !this.isShowModal;
    },
    handleInquire() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("문의사항을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (!this.inquiryData["enterPath"] && !this.inquiryData["enterPathText"]) {
        alert("유입경로를 선택 및 기타에 입력해주세요");
        flag = true;
        return false;
      }
      if (!flag) {
        const find = this.pathValue.find((findItem) => findItem["key"] === this.inquiryData["enterPath"]);
        const pathText = find ? find["value"] : "";
        this.inquiryData["enterPath"] = pathText;

        this.axios
          .get(`/rest/external/addSMP`, { params: this.inquiryData })
          .then((res) => {
            if (res.data.err === 0) {
              alert("문의가 완료되었습니다.");
              this.gtag_report_conversion(window.location.href);
              this.$gtag('event', 'conversion', {'send_to': 'AW-11452452150/CYnaCJ7T0YcZELaa-tQq','event_callback': this.gtagCallback});
              let wcs_add = {};
              let _nasa = {};
              wcs_add["wa"] = "s_1f1354ae10d6";
              //페이스북 픽셀
              if (window.fbq)
                window.fbq("track", "Purchase", {
                  value: 0.0,
                  currency: "KRW",
                });
              // 네이버 검색광고 스크립트 적용
              if (window.wcs) {
                //  전환페이지 설정
                _nasa["cnv"] = wcs.cnv("1", "10");
                //  공통 스크립트 적용
                wcs.inflow(window.location.href);
                window.wcs_do(_nasa);
              }

              this.inquiryData = {
                company: "", //고객사명
                manager: "", //담당자
                email: "", //이메일
                contents: "", //내용
                category: "inbound",
                agree: false,
                phone: "", //앞자리
                enterPath: "",
                enterPathText: "",
                enterUrl: window.location.href, //사이트주소
              };
              this.selectEnterPath = "";
              this.selectEnterPathText = "";
            } else {
              alert(res.data.err_msg);
            }
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
    openPage(path) {
      window.open(path, "_blank");
    },
    handleIsDispatch() {
      document.getElementById("box_01").scrollIntoView();
      this.isMenu = !this.isMenu;
    },
    handleIsDispatchBefore() {
      document.getElementById("box_02").scrollIntoView();
      this.isMenu = !this.isMenu;
    },
    handleIsDeparture() {
      document.getElementById("box_03").scrollIntoView();
      this.isMenu = !this.isMenu;
    },
    handleIsDispatchIng() {
      document.getElementById("box_04").scrollIntoView();
      this.isMenu = !this.isMenu;
    },
    handleIsReturn() {
      document.getElementById("box_05").scrollIntoView();
      this.isMenu = !this.isMenu;
    },
    
  },

  watch: {
    selectEnterPath: function (val) {
      if (val === "path7") {
        this.inquiryData.enterPath = "";
      } else {
        this.inquiryData.enterPath = val;
        this.inquiryData.enterPathText = "";
        this.selectEnterPathText = "";
      }
    },

    selectEnterPathText: function (val) {
      this.inquiryData.enterPathText = val;
    },
  },
};
</script>

<style lang="scss">
input {
  -webkit-border-radius: 0;
}
.br {
  display: block !important;
}
.br_2 {
  display: block !important;
}
p {
  word-break: keep-all;
}
html {
  scroll-behavior: smooth;
}
//개인정보처리방침(팝업창)
/* 팝업창 셋팅 */
.use_pop_container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow: auto;
}
.sns-family-wrapper {
  font-size: 12px;
  color: #999999;
  width: 1450px;
  margin: 0 auto;

  .sns-wrapper {
    display: flex;
    align-items: center;
    gap: 0 5px;

    ul {
      display: flex;
      gap: 0 5px;

      li img {
        cursor: pointer;
      }
    }
  }
}
.use_pop_container::-webkit-scrollbar {
  display: none;
}
.use_pop_box {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
  border-radius: 16px;
  text-align: right;
  img {
    width: 20px;
    margin-bottom: 25px;
  }
}
.use_pop {
  height: 700px;
  background-color: #fff;
  padding: 0 20px 20px 20px;
  border-radius: 16px;
  overflow: auto;
  h2 {
    font-size: 25px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15px;
  }
  p {
    text-align: justify;
  }
}
// 둥둥이
.page_container {
  position: relative;
}
.side_btn {
  position: fixed;
  bottom: 250px;
  right: 50px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 4px 5px 26px rgba(0, 0, 0, 0.09);
  padding: 20px 10px;
  text-align: center;
  z-index: 1;

  h4 {
    margin-top: 5px;
    font-size: 15px;
  }
  .estimate {
    a {
      border-bottom: 1px solid #e4e4e4;
      padding: 0 18px 20px;
      margin-bottom: 20px;
      color: #000;
      display: block;
    }
  }
  .question {
    a {
      padding: 0 18px;
      color: #000;
      display: block;
    }
  }
}
// 메인 상단
main {
  padding: 0 10%;
  margin: 0 auto;
  background: url(~@/assets/img/relocation/main_bg.png) no-repeat center top;
  background-size: cover;
  padding-bottom: 136px;
  border-radius: 0 0 40px 0;
  header {
    display: block;
    padding-top: 36px;
    padding-bottom: 130px;
  }
  h1 {
    line-height: 1.3;
    font-weight: bold;
    font-size: 95px;
    color: #fff;
    padding-bottom: 67px;
    filter: drop-shadow(7px 0px 13px rgba(0, 0, 0, 0.17));
    span {
      display: block;
      font-size: 45px;
      font-weight: 500;
    }
  }
  .btn {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 20px;
    a {
      background-color: #1e7ee1;
      color: #fff;
      font-weight: bold;
      display: inline-block;
      padding: 18px 33px;
      border-radius: 30px;
    }
    img {
      padding-left: 10px;
      padding-bottom: 3px;
    }
  }
  .btn_estimate {
    display: none;
    margin-right: 20px;
    a {
      display: inline-block;
      background-color: rgba(0, 0, 0, 0.13);
      border: 1px solid #fff;
      color: #fff;
      font-weight: bold;
      padding: 18px 33px;
      border-radius: 30px;
    }
    img {
      padding-left: 7px;
      padding-bottom: 3px;
    }
  }
  .btn_question {
    display: none;
    a {
      display: inline-block;
      background-color: rgba(0, 0, 0, 0.13);
      border: 1px solid #fff;
      color: #fff;
      font-weight: bold;
      padding: 18px 33px;
      border-radius: 30px;
    }
    img {
      padding-left: 7px;
      padding-bottom: 3px;
    }
  }
}
// 섹션01
.section_01 {
  width: fit-content;
  text-align: center;
  width: 90%;
  margin: 100px auto 95px;
  line-height: 1.3;
  word-break: keep-all;
  h2 {
    span {
      color: #1e7ee1;
    }
    font-size: 50px;
    font-weight: bold;
    margin-bottom: 35px;
  }
  p {
    font-size: 20px;
    span {
      font-weight: bold;
    }
  }
}
//네비게이션
nav {
  border-top: 1px solid #dddddd;
  ul {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 35px 0;
    li {
      a {
        display: inline-block;
        font-size: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        color: #000;
      }
      span {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #4b9ef3;
        text-indent: -9999px;
        display: inline-block;
        margin-right: 8px;
      }
      &.li_02 {
        span {
          background-color: #7247ff;
        }
      }
      &.li_03 {
        span {
          background-color: #fe833a;
        }
      }
      &.li_04 {
        span {
          background-color: #00bc89;
        }
      }
      &.li_05 {
        span {
          background-color: #ff9e94;
        }
      }
    }
  }
}
// 섹션02
.section_02 {
  background-color: #0f0f10;
  background: url(~@/assets/img/relocation/road_bg.png) no-repeat center top;
  background-size: cover;
  text-align: center;
  padding: 140px 0 0 0;
  .dot {
    margin-bottom: 15px;
  }
  h2 {
    font-weight: bold;
    font-size: 55px;
    color: #fff;
    filter: drop-shadow(6px 0px 13px rgba(0, 0, 0, 1));
  }
  .box_01 {
    width: 915px;
    margin: 0 auto 200px;
    .img_box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .txt_box {
        text-align: left;
        margin-bottom: 25px;
        h3 {
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        p {
          color: #858587;
          font-size: 16px;
          line-height: 1.4;
        }
      }
    }
  }
  .step_box_01 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    margin-top: 80px;
  }
  .gray_box {
    background-color: rgba(37, 37, 37, 0.9);
    padding: 25px 0 25px 20px;
    border-radius: 16px;
    width: 240px;
    height: 204px;
    text-align: left;
    h4 {
      color: #909090;
      font-size: 14px;
      margin-top: 10px;
      margin-bottom: 5px;
    }
    h3 {
      color: #fff;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.3;
      span {
        color: #4b9ef3;
        &.w_blue {
          color: #22a5d0;
        }
      }
    }
  }

  // 파견 전 (02)
  .box_defalt {
    width: 915px;
    margin: 0 auto 195px;
    .img_container {
      display: flex;
      justify-content: space-between;
      text-align: left;
      h3 {
        color: #7247ff;
        font-weight: bold;
        font-size: 24px;
        margin-top: 18px;
        margin-bottom: 10px;
      }
      p {
        color: #858587;
        font-size: 16px;
      }
      .img_box {
        &:last-child {
          margin-top: 75px;
        }
      }
    }
    &.box_02 {
      margin-bottom: 192px;
    }
    &.box_03 {
      margin-bottom: 201px;
      h3 {
        color: #fe833a;
      }
    }
    &.box_04 {
      margin-bottom: 200px;
      h3 {
        color: #00bc89;
      }
    }
    &.box_05 {
      padding-bottom: 119px;
      margin-bottom: 0;
      h3 {
        color: #ff9e94;
      }
    }
    h2 {
      margin-bottom: 90px;
    }
  }
}
// 섹션03
.section_03 {
  margin-top: 125px;
  text-align: center;
  h2 {
    font-size: 50px;
    font-weight: bold;
    margin: 0 auto;
    margin-bottom: 45px;
    width: 90%;
    word-break: keep-all;
    line-height: 1.3;
  }
  p {
    font-size: 20px;
    margin-bottom: 50px;
    span {
      font-weight: bold;
    }
  }
  // WODUCATION 박스
  .onestop_box {
    width: 1000px;
    margin: 0 auto;
    border-radius: 16px;
    border: 2px solid #1e7ee1;
    box-shadow: 6px 0 24px rgba(43, 43, 43, 0.07);
    padding: 35px 0;
    h3 {
      font-size: 35px;
      font-weight: bold;
    }
    p {
      color: #1e7ee1;
      font-size: 18px;
      span {
        padding: 0 10px;
      }
    }
    .lr_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 35px;
      h4 {
        font-size: 20px;
        font-weight: bold;
      }
      .diagram_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 71%;
        margin: 0 auto;
        position: relative;
        padding: 20px 0;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          filter: drop-shadow(6px 0 16px rgba(43, 43, 43, 0.23));
          width: 34px;
        }
      }
      .circle_01 {
        border: 2px solid #1e7ee1;
        background-color: #fff;
        color: #1e7ee1;
        width: 152px;
        height: 152px;
        padding-top: 40px;
        border-radius: 50%;
        font-size: 16px;
        font-weight: 500;
        &.circle_001 {
          background-color: #1e7ee1;
          color: #fff;
          padding-top: 50px;
        }
      }
      .circle_02 {
        border: 2px solid #0c96c3;
        background-color: #fff;
        color: #0c96c3;
        width: 152px;
        height: 152px;
        padding-top: 50px;
        border-radius: 50%;
        font-size: 16px;
        font-weight: 500;
        &.circle_002 {
          background-color: #0c96c3;
          color: #fff;
          padding-top: 40px;
        }
      }
      p {
        text-align: center;
        font-size: 15px;
        color: #666666;
        margin: 0;
      }
    }
    .l_box {
      background-color: #f1f1f3;
      border-radius: 16px;
      width: 48%;
      padding: 30px 0;
    }
    .r_box {
      background-color: #f1f1f3;
      border-radius: 16px;
      width: 48%;
      padding: 30px 0;
    }
  }
  .arrow_circle {
    margin: 35px 0 10px;
  }
  .sub_txt {
    text-align: left;
    width: 1000px;
    margin: 0 auto;
    font-size: 40px;
    span {
      color: #1e7ee1;
    }
  }
  // 리로케이션 서비스 4가지
  .service_img_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1000px;
    margin: 70px auto 100px;
    p {
      font-size: 16px;
      color: #444444;
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
}
// 섹션04
.section_04 {
  background-color: #f9f9fa;
  background: url(~@/assets/img/relocation/process_bg.png) no-repeat center top;
  background-size: cover;
  h2 {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
    padding-top: 108px;
  }
  p {
    font-size: 15px;
    color: #666666;
    text-align: right;
    width: 1000px;
    margin: 30px auto 0;
    padding-bottom: 104px;
    span {
      font-weight: bold;
    }
  }
  .process_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1000px;
    margin: 0 auto;
    li {
      background-color: #fff;
      box-shadow: 6px 0 24px rgba(43, 43, 43, 0.07);
      text-align: left;
      width: 30%;
      border-radius: 16px;
      padding: 35px 18px;
      h4 {
        font-weight: bold;
        color: #1e7ee1;
        font-size: 16px;
        margin: 20px 0 0;
      }
      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 13px;
      }
      p {
        font-size: 16px;
        color: #444444;
        width: auto;
        text-align: left;
        margin: 0;
        padding: 0;
      }
    }
  }
}
// 섹션05
.section_05 {
  background-color: #0f0f10;
  padding-bottom: 115px;
  h2 {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    padding-top: 120px;
    color: #fff;
  }
  p {
    text-align: center;
    color: #858587;
    font-size: 20px;
    margin-bottom: 60px;
  }
  .question_container {
    display: flex;
    justify-content: space-between;
    width: 1000px;
    margin: 0 auto;
  }
  .question_box {
    background-color: #252525;
    border-radius: 16px;
    box-shadow: 19px 0 21px rgba(0, 0, 0, 0.72);
    width: 48%;
    padding: 34px 30px;
    label {
      display: block;
      color: #939299;
      font-size: 15px;
      font-family: "Noto Sans KR", sans-serif;
      margin-bottom: 2px;
    }
    input {
      font-size: 18px;
      font-family: "Noto Sans KR", sans-serif;
      border-bottom: 1px solid #787879;
      width: 100%;
      margin-bottom: 30px;
      color: #fff;
      height: 28px;
    }
    input::placeholder {
      color: #3f3f3f;
    }
    input:focus {
      outline: none;
    }
    textarea {
      width: 100%;
      border: 1px solid #787879;
      border-radius: 16px;
      margin-top: 10px;
      color: #fff;
      font-size: 15px;
    }
    textarea:focus {
      outline: none;
    }
    .btn {
      background-color: #1e7ee1;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      border-radius: 16px;
      padding: 13px 0;
      text-align: center;
      margin-top: 30px;
    }
    .check_label {
      text-align: right;
      margin-top: 10px;
      input {
        width: auto;
        margin: 0;
        margin-right: 5px;
      }
      span {
        border-bottom: 1px solid #787879;
      }
    }

    .funnel-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 30px;

      li {
        display: flex;
        align-items: center;
        gap: 0 5px;

        label {
          font-size: 13px;
          color: #ffffff;
        }

        input[type="radio"] {
          width: auto;
          margin-bottom: 0;
        }

        input[type="text"] {
          width: auto;
          font-size: 13px;
          color: #ffffff;
          margin-bottom: 0;
        }

        &.etc {
          width: 100%;
        }
      }
    }
  }
  .map_box {
    position: relative;
    width: 48%;
    // height: 100vh;
    height: 682px;
    border-radius: 16px;
    box-shadow: 19px 0 21px rgba(0, 0, 0, 0.72);

    iframe {
      border-radius: 16px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
footer {
  background-color: #000000;
  color: #fff;
  padding: 40px 0 90px;
  .footer_container {
    width: 1450px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    h4 {
      color: #dddddd;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 8px;
    }
    p {
      color: #686868;
      font-size: 15px;
    }
  }
  .left {
    display: flex;
    .contact_box {
      margin-right: 40px;
    }
  }
  .right {
    text-align: right;
  }
  .btn {
    a {
      display: inline-block;
      color: #1e7ee1;
      font-weight: 500;
      border-radius: 12px;
      border: 1px solid #1e7ee1;
      padding: 8px 25px;
      text-align: center;
      width: fit-content;
      margin-bottom: 15px;
    }
  }
}
/* 1450px 이하 */
@media only screen and (max-width: 1450px) {
  .use_pop_box {
    width: 80%;
  }
  footer {
    .footer_container {
      width: 1000px;
    }
  }
}

/* 1000px 이하 */
@media only screen and (max-width: 1000px) {
  nav {
    ul {
      width: 90%;
    }
  }
  .section_03 {
    .onestop_box {
      width: 90%;
      .lr_box {
        .diagram_box {
          width: 79%;
        }
      }
    }
  }
  .section_03 {
    .sub_txt {
      width: 90%;
    }
    .service_img_box {
      width: 90%;
    }
  }
  .section_04 {
    .process_container {
      width: 90%;
      li {
        height: 287px;
      }
    }
    p {
      width: 90%;
    }
  }
  .section_05 {
    .question_container {
      width: 90%;
    }
  }
  footer {
    .footer_container {
      width: 90%;
      flex-direction: column;
      align-items: flex-start;
    }
    .right {
      text-align: left;
      margin-top: 62px;
    }
  }
}
/* 912px 이하 */
@media only screen and (max-width: 912px) {
  .br {
    display: none !important;
  }
  main {
    h1 {
      font-size: 75px;
      span {
        font-size: 38px;
      }
    }
  }
  .section_02 {
    background: url(~@/assets/img/relocation/road_bg_m.png) no-repeat center top;
    .box_01 {
      width: 90%;
      .img_box {
        img {
          width: 58%;
        }
        .txt_box {
          width: 40%;
        }
      }
    }
    .gray_box {
      width: 205px;
      height: 194px;
      h3 {
        font-size: 20px;
      }
    }
    .box_defalt {
      width: 90%;
      .img_container {
        .img_box {
          width: 45%;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .section_03 {
    p {
      width: 90%;
      margin: 0 auto 50px;
    }
    .onestop_box {
      .lr_box {
        .diagram_box {
          width: 85%;
        }
        p {
          margin: 0 auto;
          font-size: 14px;
        }
      }
    }
    .service_img_box {
      p {
        font-size: 15px;
      }
    }
  }
}
/* 850px 이하 */
@media only screen and (max-width: 850px) {
  .br_2 {
    display: none !important;
  }
  .section_03 {
    p {
      margin: 0 auto 37px;
    }
    .onestop_box {
      padding: 35px 0 25px;
      .lr_box {
        padding: 0 25px;
        .circle_01 {
          width: 148px;
          height: 148px;
          font-size: 15px;
        }
        .diagram_box {
          width: 94%;
        }
      }
      .l_box {
        height: 320px;
      }
      .r_box {
        height: 320px;
        .circle_02 {
          width: 148px;
          height: 148px;
          font-size: 15px;
        }
      }
    }
    .service_img_box {
      align-items: flex-start;
    }
  }
  .service_img_01 {
    width: 40%;
    margin-right: 3%;
    img {
      width: 100%;
    }
  }
  .service_img_02 {
    width: 40%;
    margin-right: 3%;
    img {
      width: 100%;
    }
  }
  .service_img_03 {
    width: 40%;
    margin-right: 3%;
    img {
      width: 100%;
    }
  }
  .service_img_04 {
    width: 40%;
    img {
      width: 100%;
    }
  }
}
/* 768px 이하 */
@media only screen and (max-width: 768px) {
  .side_btn {
    display: none;
  }
  main {
    h1 {
      font-size: 60px;
      span {
        font-size: 30px;
      }
    }
    .btn_estimate {
      display: inline-block;
    }
    .btn_question {
      display: inline-block;
    }
  }
  nav {
    display: none;
  }
  .section_01 {
    margin: 70px auto;
    h2 {
      font-size: 40px;
      margin-bottom: 18px;
    }
    p {
      font-size: 18px;
    }
  }
  .section_02 {
    h2 {
      font-size: 45px;
    }
    .step_box_01 {
      margin-top: 54px;
      li {
        img {
          display: none;
        }
      }
      .gray_box {
        img {
          display: block;
        }
      }
    }
    .box_defalt {
      h2 {
        margin-bottom: 58px;
      }
    }
  }
  .section_03 {
    h2 {
      font-size: 40px;
      margin-bottom: 18px;
    }
    p {
      font-size: 18px;
    }
    .onestop_box {
      .lr_box {
        flex-direction: column;
      }
      .l_box {
        height: auto;
        width: 100%;
        margin-bottom: 20px;
        .diagram_box {
          width: 300px;
        }
      }
      .r_box {
        height: auto;
        width: 100%;
        .diagram_box {
          width: 300px;
        }
      }
    }
    .sub_txt {
      font-size: 30px;
    }
    .service_img_box {
      margin: 50px auto 68px;
    }
  }
  .section_04 {
    h2 {
      font-size: 40px;
      margin-bottom: 40px;
      padding-top: 71px;
    }
  }
  .section_05 {
    h2 {
      font-size: 40px;
      margin-bottom: 18px;
    }
    p {
      font-size: 18px;
    }
    .question_container {
      flex-direction: column;
    }
    .question_box {
      width: 100%;
      margin-bottom: 30px;
      height: auto;
    }
    .map_box {
      width: 100%;
      height: 264px;
      iframe {
        height: 264px;
      }
    }
  }
}
/* 700px 이하 */
@media only screen and (max-width: 700px) {
  .section_02 {
    .gray_box {
      width: 186px;
      height: 185px;
      h3 {
        font-size: 18px;
      }
    }
  }
  .section_04 {
    .process_container {
      li {
        height: 304px;
        h3 {
          line-height: 1.3;
          font-size: 20px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
/* 640px 이하 */
@media only screen and (max-width: 640px) {
  .br_3 {
    display: none;
  }
  .section_02 {
    .step_box_01 {
      flex-direction: column;
      .gray_box {
        img {
          display: inline-block;
          margin-right: 15px;
        }
      }
    }
    .gray_box {
      width: 100%;
      height: auto;
      margin-bottom: 20px;
      padding: 25px 20px 18px 20px;
      h4 {
        font-size: 18px;
        display: inline-block;
        margin-right: 10px;
      }
      h3 {
        display: inline-block;
      }
    }
    .box_01 {
      margin: 0 auto 130px;
      .img_box {
        flex-direction: column;
        align-items: flex-start;
        img {
          width: 100%;
          margin-bottom: 20px;
        }
        .txt_box {
          width: 100%;
        }
      }
    }
    .box_defalt {
      &.box_02 {
        margin-bottom: 130px;
      }
      &.box_03 {
        margin-bottom: 130px;
      }
      &.box_04 {
        margin-bottom: 130px;
      }
    }
  }
  .section_03 {
    .service_img_box {
      flex-wrap: wrap;
    }
  }
  .service_img_01 {
    width: 45%;
    margin-right: 0;
  }
  .service_img_02 {
    width: 45%;
    margin-right: 0;
  }
  .service_img_03 {
    width: 45%;
    margin-right: 0;
    margin-top: 30px;
  }
  .service_img_04 {
    width: 45%;
    margin-right: 0;
    margin-top: 30px;
  }
  .section_04 {
    .process_container {
      flex-direction: column;
      li {
        width: 100%;
        height: auto;
        margin-bottom: 20px;
      }
    }
    p {
      text-align: left;
      margin: 10px auto 0;
      padding-bottom: 115px;
    }
  }
  .section_05 {
    p {
      width: 90%;
      margin: 0 auto 60px;
    }
  }
  footer {
    .left {
      flex-direction: column;
      .contact_box {
        margin-right: 0;
        margin-bottom: 30px;
      }
    }
  }
}
/* 570px 이하 */
@media only screen and (max-width: 570px) {
  main {
    padding-bottom: 88px;
    header {
      padding-bottom: 90px;
    }
    h1 {
      font-size: 50px;
      span {
        font-size: 25px;
      }
    }
    .btn {
      font-size: 15px;
    }
    .btn_estimate {
      a {
        font-size: 15px;
      }
    }
    .btn_question {
      a {
        font-size: 15px;
      }
    }
  }
  .section_02 {
    .box_defalt {
      .img_container {
        flex-direction: column;
        .img_box {
          width: 100%;
        }
      }
    }
  }
}
/* 460px 이하 */
@media only screen and (max-width: 460px) {
  .use_pop_box {
    width: 90%;
  }
  .use_pop {
    p {
      text-align: left;
    }
  }
  main {
    padding-bottom: 80px;
    background-position: 70%;
    header {
      padding-bottom: 70px;
    }
    h1 {
      font-size: 38px;
      padding-bottom: 40px;
      span {
        font-size: 20px;
      }
    }
    .btn {
      font-size: 13px;
      display: block;
      margin-bottom: 15px;
      width: 100%;
      text-align: center;
      a {
        display: block;
        padding: 16px 33px;
      }
      img {
        display: none;
      }
    }
    .btn_estimate {
      display: block;
      margin-bottom: 15px;
      width: 100%;
      text-align: center;
      a {
        font-size: 13px;
        padding: 15px 20px;
        display: block;
      }
      img {
        display: none;
      }
    }
    .btn_question {
      display: block;
      width: 100%;
      text-align: center;
      a {
        font-size: 13px;
        padding: 15px 20px;
        display: block;
      }
      img {
        display: none;
      }
    }
  }
  .section_01 {
    margin: 60px auto;
    h2 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
    }
  }
  .section_02 {
    padding: 75px 0 0 0;
    h2 {
      font-size: 30px;
    }
    .step_box_01 {
      margin-top: 40px;
      margin-bottom: 30px;
      .gray_box {
        padding: 18px 20px 18px 20px;
        img {
          width: 33px;
          margin-right: 10px;
        }
        h4 {
          font-size: 15px;
        }
        h3 {
          font-size: 15px;
          display: block;
          margin-top: 10px;
        }
      }
    }
    .box_01 {
      margin: 0 auto 60px;
      .img_box {
        .txt_box {
          p {
            font-size: 15px;
          }
        }
      }
    }
    .box_defalt {
      &.box_02 {
        margin-bottom: 70px;
      }
      &.box_03 {
        margin-bottom: 70px;
      }
      &.box_04 {
        margin-bottom: 70px;
      }
      &.box_05 {
        padding-bottom: 70px;
      }
      h2 {
        margin-bottom: 40px;
      }
      .img_container {
        h3 {
          font-size: 20px;
        }
        p {
          font-size: 15px;
        }
        .img_box {
          &:last-child {
            margin-top: 50px;
          }
        }
      }
    }
  }
  .section_03 {
    margin-top: 60px;
    h2 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
    }
    .onestop_box {
      h3 {
        font-size: 30px;
      }
      p {
        font-size: 15px;
      }
      .lr_box {
        padding: 0 20px;
        p {
          font-size: 13px;
        }
        .circle_01 {
          width: 120px;
          height: 120px;
          font-size: 13px;
          padding-top: 33px;
          &.circle_001 {
            padding-top: 40px;
          }
        }
        .circle_02 {
          width: 120px;
          height: 120px;
          font-size: 13px;
          padding-top: 40px;
          &.circle_002 {
            padding-top: 33px;
          }
        }
      }
      .l_box {
        .diagram_box {
          width: 248px;
        }
      }
      .r_box {
        .diagram_box {
          width: 248px;
        }
      }
    }
    .arrow_circle {
      margin: 35px 0 20px;
    }
    .sub_txt {
      font-size: 25px;
    }
    .service_img_box {
      margin: 40px auto 60px;
    }
  }
  .section_04 {
    h2 {
      font-size: 30px;
      padding-top: 60px;
    }
    p {
      padding-bottom: 60px;
      font-size: 14px;
    }
    .process_container {
      li {
        p {
          font-size: 15px;
        }
      }
    }
  }
  .section_05 {
    h2 {
      font-size: 30px;
      padding-top: 60px;
    }
    p {
      font-size: 16px;
      margin: 0 auto 40px;
    }
  }
}
</style>
